export class TokenService {
    public static getHeaderToken() {
        return { headers : {'Authorization': `Bearer ${TokenService.tokenGetter()}`}};
    }

    public static tokenGetter(): string {
        return sessionStorage.getItem("access_token");
    }

    deleteToken() {
        sessionStorage.clear();
    }
    
    setToken(token: string): void {
        sessionStorage.setItem("access_token", token);
    }

    setRole(role: any) {
        sessionStorage.setItem("role", JSON.stringify(role));
    }

    getRole() {
        return JSON.parse(sessionStorage.getItem("role"));
    }
}